module.exports = __webpack_public_path__ + "fonts/THICCCBOI-ExtraBold.b5842d86.woff";